import {ChangeDetectorRef, Component, NgZone, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {User} from '../../../../models/user';
import {AuthService} from '../../../../auth-n-routing/auth-service.service';
import {Travel} from '../../../../models/travel';
import {UserAdministratePark} from '../../../../models/userAdministrateParks';
import {UsersAdministrateParksHandlerService} from '../../../../api-handlers/users-administrate-parks-handler.service';

@Component({
  selector: 'app-manage-profiles',
  templateUrl: './manage-profiles.component.html',
  styleUrls: ['./manage-profiles.component.css']
})
export class ManageProfilesComponent implements OnInit {

  parkId: number;
  parkName: string;
  mydataz = {
    users: []
  };
  user:User;

  userAdministrateParksList: UserAdministratePark[];

  constructor(
    private activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private changeDetector: ChangeDetectorRef,
    public userAdministrateParkService : UsersAdministrateParksHandlerService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.parkId = Number(params.get('parkId'));
      this.parkName = decodeURI(params.get('parkName'));
    });
    this.reload();
  }


  reload(){
    this.userAdministrateParkService.getUserAdmistrateParkByParkID(this.parkId).then((userAdministrateParksList: UserAdministratePark[]) => {
     this.ngZone.run(() => {
        this.userAdministrateParksList = userAdministrateParksList;
        this.changeDetector.detectChanges();
      });
    });
  }

  onUserNameChanged(value: string) {

    this.user = null;
    if (value && value.length > 2) {
      let v = value.trim();
      v = v.replace(/ /g, '');
      this.authService.findUser(v).then((users: User[]) => {
        this.ngZone.run(() => {
          this.mydataz.users = users;
          if (users.length > 0) {
            this.user = users[0];
          }
        });
      });
    }
  }

  userSelected(user: User) {
    this.user = user;
  }


  addUserAdministrateParks() {
    const r = confirm(
      'Stai aggiungendo: \n' +
       this.user.name + ' ' + this.user.surname + ' ' + this.user.cod_fiscale + '\n' +
      'come amministratore del parco ' + this.parkName);
    if (r === true) {
      let idUser = this.user.id;
      let idPark = this.parkId;
      this.userAdministrateParkService.addUserAdministrateParks(idUser, idPark).then((uad: UserAdministratePark) => {
          console.log(uad);
          this.reload();
      });
    }
  }


  deleteUserAdministrateParks(uadId,uadUser){
    const r = confirm(
      'Stai eliminando: \n' +
      uadUser + '\n' +
      'come amministratore del parco ' + this.parkName);
    if (r === true) {
      this.userAdministrateParkService.deleteUserAdmistrateParkByUadID(uadId).then(res => {
        console.log(res);
        this.reload();
      });
    }
  }
  restoreUserAdministrateParks(uadId,uadUser){
      const r = confirm(
        'Stai ripristinando: \n' +
        uadUser + '\n' +
        'come amministratore del parco ' + this.parkName);
      if (r === true) {
        this.userAdministrateParkService.restoreUserAdmistrateParkByUadID(uadId).then(res => {
          console.log(res);
          this.reload();
        });
      }
    }

}
